import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthenticationService } from '@auth/services/authentication/authentication.service';
import { ToastrService } from '@shared/services/toastr/toastr.service';
import { TranslateService } from '@shared/translate/translate.service';
import { catchError, throwError } from 'rxjs';

const Unauthorized = 401;

export const ErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const _toast = inject(ToastrService);
  const _auth = inject(AuthenticationService);
  const _translate = inject(TranslateService);

  return next(req).pipe(
    catchError(({ error, status, statusText }: HttpErrorResponse) => {
      let message = statusText ?? _translate.instant('xErrorInesperado');

      if (typeof error === 'string') {
        message = error;
      } else if (typeof error?.msg === 'string') {
        message = error.msg;
      } else if (error?.errors && typeof error.errors === 'object' && !Array.isArray(error.errors)) {
        message = Object.values(error.errors)
          .map((e) => (Array.isArray(e) ? e.join('\n') : e))
          .join('\n');
      }

      if (status === Unauthorized) {
        _auth.logout();
      }

      _toast.error(message);
      return throwError(() => message);
    }),
  );
};
